export default __webpack_public_path__ + "static/media/Victoria_Valdivia_AHV_In_Moms_We_Trust.943d258b.jpg";